import { render, staticRenderFns } from "./VikiFace.vue?vue&type=template&id=cebf3bb8&scoped=true&"
import script from "./VikiFace.vue?vue&type=script&lang=js&"
export * from "./VikiFace.vue?vue&type=script&lang=js&"
import style0 from "./VikiFace.vue?vue&type=style&index=0&id=cebf3bb8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cebf3bb8",
  null
  
)

export default component.exports